export const DEFAULT_EMAIL_PATTERN =
  "^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$";
export const LETTER_ONLY_PATTERN = '^[A-Za-z\\s]+$';
export const ALPHANUMERIC_PATTERN = '^[a-zA-Z0-9\\.ë\\s]+$';
export const FORBIDDEN_CHARS_PATTERN = '^[^{}|/\\\\\\\\()<>:[;]+$';
export const NUMERIC_PATTERN = '^[0-9]+$';
export const NUMERIC_WITH_SEPARATOR_PATTERN = '^/^[0-9,]*$/$';
export const GUID_PATTERN =
  '^[0-9A-Fa-f]{8}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{12}$';

export const DEFAULT_EMAIL_PATTERN_REGEX =
  /^[A-Z0-9._%+-]+@[A-Z0-9-]+(\.[A-Z-]+)*\.[A-Z]{2,}$/i;
